export default {"src":"/_next/static/media/CECA_Home_Icon_Pig.b4f6d338.svg","height":50,"width":50};